import yup from '../../../config/yup';

export const moodleReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('moodleReader'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string(),
  format: yup.string(),
  onError: yup.string(),
  connectionKey: yup.string(),
  properties: yup.object().shape({
    path: yup.string().required('Path is required'),
    rootUrl: yup.string().required('Root URL is required'),
    token: yup.string().required('Token is required'),
  }),
});
